import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { useWorkspaces } from '../Orchestrator/WorkspaceProvider';

/**
 * Redirects to the models page if the URL matches the pattern #projects/:uuid/experiments.
 * This is used to handle the equivalent of DAI -> old MLOps redirect.
 */
const DAIRedirect = () => {
  const location = useLocation(),
    history = useHistory(),
    { activeWorkspace } = useWorkspaces(),
    [pathToRedirectTo, setPathToRedirectTo] = React.useState<string>();

  React.useEffect(() => {
    // Matches pattern: #projects/:uuid/experiments
    const match = location.hash.match(/^#projects\/([^/]+)\/experiments$/);

    if (match) {
      const projectId = match[1];
      setPathToRedirectTo(`/mlops/workspaces/${projectId}/models`);
    }
  }, [location.hash]);

  React.useEffect(() => {
    if (activeWorkspace && pathToRedirectTo) {
      history.push(pathToRedirectTo);
      setPathToRedirectTo(undefined);
    }
  }, [pathToRedirectTo, activeWorkspace]);

  return null;
};

export default DAIRedirect;
